module.exports = __webpack_public_path__ + "static/media/01.188dd865.webp";